// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
import { Link } from "react-router-dom";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet";
import {
  Typeset,
  Typepad,
  ImgPad,
  ImgIso,
  BgColor,
  BgColor2,
  DatesRange
} from "../../Partials/Typeset";
import { ThemeColors } from "../../Partials/ThemeColors";
import { Button, ButtonSecondary } from "../../Partials/Button";
import {
  colors,
  sizes,
  expandValue,
  breakpoints
} from "../../../helpers/theme";
import { Footer } from "../../Partials/Ui";
import { Lightbox } from "../../Partials/Lightbox";
import { work } from "../../../helpers/data";
import { slugify } from "../../../helpers/utils";
import { Graph, LegendStyled, LineGraph, Legend } from "../../Partials/Graphs";

import { ThemeProvider } from "emotion-theming";
import InViewMonitor from "react-inview-monitor";
import animateScrollTo from "animated-scroll-to";


import p_frv_web_1 from "../../../images_hd/Pcg/p_frv_web_1.jpg";
import p_frv_web_1bg from "../../../images_hd/Pcg/p_frv_web_1bg.jpg";
//import p_frv_web_2 from '../../../images_hd/Pcg/p_frv_web_2.mp4'

import p_frv_mobile_1 from "../../../images_hd/Pcg/p_frv_mobile_1.jpg";
import p_frv_mobile_2 from "../../../images_hd/Pcg/p_frv_mobile_2.jpg";
import p_frv_mobile_3 from "../../../images_hd/Pcg/p_frv_mobile_3.jpg";

import p_frv_map_mobile from "../../../images_hd/Pcg/p_frv_map_mobile.jpg";
import p_frv_map_web from "../../../images_hd/Pcg/p_frv_map_web.jpg";
import p_frv_map_tablet from "../../../images_hd/Pcg/p_frv_map_tablet.jpg";
//import p_frv_map_bg from '../../../images_hd/Pcg/p_frv_map_bg.jpg'

import frv_blog_nav from "../../../images_hd/Pcg/frv_blog_nav.jpg";
import frv_blog_tablet from "../../../images_hd/Pcg/frv_blog_tablet.jpg";
import frv_blog_web from "../../../images_hd/Pcg/frv_blog_web.jpg";

import { RadialChart } from "react-vis";

var tinycolor = require("tinycolor2");
var chroma = require("chroma-js");
var $ = require("jquery");

let GridStyles = props => css`
  @media (min-width: ${expandValue(breakpoints[2])}) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-column-gap: ${expandValue(sizes.space * 2)};
  }
`;
let Grid = styled("div")`
  ${GridStyles}
`;

let ImgGridStyles = props => css`
  padding: ${expandValue(sizes.space)};
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  @media (min-width: ${expandValue(breakpoints[2])}) {
    padding: ${expandValue(sizes.space * 2)};
    .bg-image {
      background-size: cover;
    }
  }
`;
let ImgGridS = styled("div")`
  ${ImgGridStyles}
`;

let CardStyles = props => css`
  @media (min-width: ${expandValue(breakpoints[3])}) {
    display: grid;
    grid-template-columns: 50% 50%;
  }
`;
let Card = styled("article")`
  ${CardStyles}
`;

// Get me only this project
let workit = work.filter(work => work.component === "WorkFracturedVeil");

export class CardFracturedVeil extends React.Component {
  render() {
    let desc =
      "Design and develop a companion app to accompany the game. The app allows the player to see what is happening on the game server in real time.";
    if (this.props.desc) {
      desc = this.props.desc;
    }
    return (
      <Card>
        <div css={{ gridColumn: "1/2" }}>
          <BgColor2 style={{ height: "100%" }}>
            <Typepad>
              <Typeset>
                <h2 style={{ marginBottom: 0 }}>Fractured Veil</h2>
                <h4 className="line">Paddle Creek Games</h4>

                <p className="text-lg">{desc}</p>
                <ul className="list-inline tags">
                  {workit[0].tags.map((tag, index) => (
                    <li key={"tag_" + index}>
                      <Link to={"/t/" + slugify(tag)}>{tag}</Link>
                    </li>
                  ))}
                </ul>

                <DatesRange>2016&ndash;Current</DatesRange>
                <Link to="/work/fracturedveil">
                  <Button>View</Button>
                </Link>
              </Typeset>
            </Typepad>
          </BgColor2>
        </div>
        <div style={{ gridColumn: "2/3" }}>
          <ImgIso dropShadow>
            <ImgPad>
              <Link to="/work/fracturedveil">
                <img src={p_frv_web_1} alt="Fractured Veil Screenshot" />
              </Link>
            </ImgPad>
            <ImgPad>
              <Link to="/work/fracturedveil">
                <img src={p_frv_map_web} alt="Fractured Veil Screenshot" />
              </Link>
            </ImgPad>
            <ImgPad>
              <Link to="/work/fracturedveil">
                <img src={frv_blog_web} alt="Fractured Veil Screenshot" />
              </Link>
            </ImgPad>
          </ImgIso>
        </div>
      </Card>
    );
  }
}

export class WorkFracturedVeil extends React.Component {
  constructor(props) {
    super(props);
    this.state = { enableTheme: false };
  }
  enableTheme(inView) {
    //console.log("inView",inView.isIntersecting)
    this.setState({ enableTheme: true });
  }
  disableTheme(inView) {
    //console.log("inView",inView.isIntersecting)
    this.setState({ enableTheme: false });
  }

  render() {
    let colorBlack = "#10100f";
    let colorWhite = "#e4e4e2";

    let colorPrimary = "#D84131";

    let colorSecondary = "#CFDE5C";

    let colorBackground1 = "#333333";
    let colorBackground2 = "#1f1f1f";
    let colorBackground3 = colorBackground1;
    let colorBackground4 = colorBackground1;
    let colorBackground5 = colorBackground2;
    let colorBackground6 = colorBackground2;

    let logoColor1 = "#D84131";
    let logoColor2 = "#ff6d5e";

    const enableTheme = this.state.enableTheme;
    let doTheDamnTheme;

    const theme = {
      colors: {
        white: colorWhite,
        black: colorBlack,
        primary: colorPrimary,
        secondary: colorSecondary,
        button1: colorPrimary,
        button2: colorSecondary,
        tertiary: colors.tertiary,
        complimentary: colors.complimentary,
        text: colors.text,
        blendSpin: 0,
        bg1: tinycolor(colorBackground1).toString(),
        bg2: tinycolor(colorBackground2).toString()
      }
    };

    if (enableTheme) {
      // Set browser color
      $("meta[name=theme-color]").remove();
      $("head").append(
        '<meta name="theme-color" content="' + colorBackground2 + '">'
      );

      doTheDamnTheme = (
        <ThemeColors
          white={colorWhite}
          black={colorBlack}
          color={colorPrimary}
          color2={colorSecondary}
          logoColor1={logoColor1}
          logoColor2={logoColor2}
          bg1={colorBackground1}
          bg2={colorBackground2}
          bg3={colorBackground3}
          bg4={colorBackground4}
          bg5={colorBackground5}
          bg6={colorBackground6}
        />
      );
    } else {
      doTheDamnTheme = "";
    }

    return (
      <ThemeProvider theme={theme}>
        <InViewMonitor
          intoViewMargin={"-50%"}
          repeatOnInView={true}
          onInView={inView => this.enableTheme(inView)}
          onNotInView={inView => this.disableTheme(inView)}
        >
          {doTheDamnTheme}

          <article data-name="fracturedveil">
            <BgColor2>
              <Typepad pageTop>
                <Typeset>
                  <Grid>
                    <div style={{ gridColumn: "1/6" }}>
                      <h2 style={{ marginBottom: 0 }}>Fractured Veil</h2>
                      <h4 className="line">Paddle Creek Games</h4>
                    </div>
                    <div style={{ gridColumn: "1/6" }}>
                      <p className="text-lg">
                        Design and develop a companion app to accompany the
                        game. The app allows the player to see what is happening
                        on the{" "}
                        <a
                          href="https://fracturedveil.com/"
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          Fractured Veil
                        </a>{" "}
                        servers in real time. Players can watch in-game drone
                        feeds as well as interact with tactical maps and manage
                        teams. Design and build social tools for organizing your
                        friends and groups.
                      </p>
                      <ul className="list-inline tags">
                        {workit[0].tags.map((tag, index) => (
                          <li key={"tag_" + index}>
                            <Link to={"/t/" + slugify(tag)}>{tag}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div
                      css={{
                        button: { width: "100%" },
                        ".date": { width: "100%" },
                        gridColumn: "6/7"
                      }}
                    >
                      <DatesRange>2016&ndash;Current</DatesRange>
                      <Link to="/work/fracturedveil">
                        <Button>View</Button>
                      </Link>
                    </div>
                  </Grid>
                </Typeset>
              </Typepad>
            </BgColor2>

            <BgColor>
              <ImgIso dropShadow>
                <ImgGridS>
                  <div style={{ gridColumn: "1/5" }}>
                    <ImgPad>
                      <Link to="/work/fracturedveil">
                        <img
                          src={p_frv_web_1}
                          alt="Fractured Veil Screenshot"
                        />
                      </Link>
                    </ImgPad>
                    <ImgPad>
                      <Link to="/work/fracturedveil">
                        <img
                          src={p_frv_map_web}
                          alt="Fractured Veil Screenshot"
                        />
                      </Link>
                    </ImgPad>
                    <ImgPad>
                      <Link to="/work/fracturedveil">
                        <img
                          src={p_frv_map_tablet}
                          alt="Fractured Veil Screenshot"
                        />
                      </Link>
                    </ImgPad>
                  </div>
                  <div style={{ gridColumn: "5/7" }}>
                    <ImgPad>
                      <Link to="/work/fracturedveil">
                        <img
                          src={p_frv_map_mobile}
                          alt="Fractured Veil Screenshot"
                        />
                      </Link>
                    </ImgPad>
                    <ImgPad>
                      <Link to="/work/fracturedveil">
                        <img
                          src={p_frv_mobile_1}
                          alt="Fractured Veil Screenshot"
                        />
                      </Link>
                    </ImgPad>
                  </div>
                </ImgGridS>
              </ImgIso>
            </BgColor>
          </article>
        </InViewMonitor>
      </ThemeProvider>
    );
  }
}

export class PageWorkFracturedVeil extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      images: [
        {
          image: p_frv_web_1,
          size: "weblg",
          alt: "Fractured Veil mobile screenshot"
        },
        {
          image: p_frv_map_mobile,
          size: "mobile",
          alt: "Fractured Veil mobile screenshot"
        },
        {
          image: p_frv_map_web,
          size: "weblg",
          alt: "Fractured Veil desktop screenshot"
        },
        {
          image: p_frv_map_tablet,
          size: "tablet",
          alt: "Fractured Veil tablet screenshot"
        },
        {
          image: frv_blog_web,
          size: "weblg",
          alt: "Fractured Veil blog screenshot"
        },
        {
          image: frv_blog_tablet,
          size: "tablet",
          alt: "Fractured Veil blog tablet screenshot"
        },
        {
          image: frv_blog_nav,
          size: "web",
          alt: "Fractured Veil blog design elements"
        },
        {
          image: p_frv_mobile_1,
          size: "mobile",
          alt: "Fractured Veil mobile screenshot"
        },
        {
          image: p_frv_mobile_2,
          size: "mobile",
          alt: "Fractured Veil mobile screenshot"
        },
        {
          image: p_frv_mobile_3,
          size: "mobile",
          alt: "Fractured Veil mobile screenshot"
        }
      ]
    };
  }

  componentDidMount() {
    const options = {
      // duration of the scroll per 1000px, default 500
      speed: 200,
      // minimum duration of the scroll
      minDuration: 0,
      // maximum duration of the scroll
      maxDuration: 200
    };
    animateScrollTo(0, options);
    $("#Top").addClass("Banished");
  }

  render() {
    let colorBlack = "#10100f";
    let colorWhite = "#e4e4e2";

    let colorPrimary = "#D84131";

    let colorSecondary = "#CFDE5C";

    let colorBackground1 = "#333333";
    let colorBackground2 = "#1f1f1f";
    let colorBackground3 = colorBackground1;
    let colorBackground4 = colorBackground1;
    let colorBackground5 = colorBackground2;
    let colorBackground6 = colorBackground2;

    let logoColor1 = "#D84131";
    let logoColor2 = "#ff6d5e";

    const theme = {
      colors: {
        white: colorWhite,
        black: colorBlack,
        primary: colorPrimary,
        secondary: colorSecondary,
        button1: colorPrimary,
        button2: colorSecondary,
        tertiary: colors.tertiary,
        complimentary: colors.complimentary,
        text: colors.text,
        blendSpin: 0,
        bg1: tinycolor(colorBackground1).toString(),
        bg2: tinycolor(colorBackground2).toString()
      }
    };

    $("meta[name=theme-color]").remove();
    $("head").append(
      '<meta name="theme-color" content="' + colorBackground2 + '">'
    );

    let colorScale = chroma.scale([colorPrimary, colorSecondary]).mode("lab");

    const projDistro = [
      { title: "Branding", angle: 14.4, color: colorScale(0) },
      { title: "Website Design", angle: 26.8, color: colorScale(0.2) },
      { title: "eCommerce", angle: 23.8, color: colorScale(0.4) },
      { title: "Companion App", angle: 26, color: colorScale(0.6) },
      { title: "Marketing", angle: 9, color: colorScale(0.8) }
    ];

    return (
      <ThemeProvider theme={theme}>
        <Helmet>
          <title>
            Case Study | Fractured Veil - Jesse Stewart | User Interface
            Designer
          </title>
          <meta
            itemprop="description"
            content="The Portfolio of Jesse Stewart, Staff Software Engineer and UX/UI Designer in East Lansing, Michigan."
          />
        </Helmet>
        <div css={{ width: "100%" }}>
          <ThemeColors
            white={colorWhite}
            black={colorBlack}
            color={colorPrimary}
            color2={colorSecondary}
            logoColor1={logoColor1}
            logoColor2={logoColor2}
            bg1={colorBackground1}
            bg2={colorBackground2}
            bg3={colorBackground3}
            bg4={colorBackground4}
            bg5={colorBackground5}
            bg6={colorBackground6}
          />
          <Typepad pageTop>
            <Typeset>
              <Grid>
                <div style={{ gridColumn: "1/6" }}>
                  <h1 style={{ marginBottom: 0 }}>Fractured Veil</h1>
                  <h4 className="line">Paddle Creek Games</h4>
                </div>
                <div style={{ gridColumn: "1/6" }}>
                  <p className="text-lg">
                    Design and develop a companion app to accompany the game.
                    The app allows the player to see what is happening on the{" "}
                    <a
                      href="https://fracturedveil.com/"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Fractured Veil
                    </a>{" "}
                    servers in real time. Players can watch in-game drone feeds
                    as well as interact with tactical maps and manage teams.
                    Design and build social tools for organizing your friends
                    and groups.
                  </p>
                  <ul className="list-inline tags">
                    {workit[0].tags.map((tag, index) => (
                      <li key={"tag_" + index}>
                        <Link to={"/t/" + slugify(tag)}>{tag}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div
                  css={{
                    button: { width: "100%" },
                    ".date": { width: "100%" },
                    gridColumn: "6/7"
                  }}
                >
                  <DatesRange>2016&ndash;Current</DatesRange>
                  <Link to="/?p=fracturedveil">
                    <ButtonSecondary>
                      Back
                    </ButtonSecondary>
                  </Link>
                </div>
              </Grid>
            </Typeset>
          </Typepad>
          <BgColor>
            <Typepad>
              <Typeset>
                <Grid>
                  <div style={{ gridColumn: "1/6" }}>
                    <LineGraph
                      id="project-timeline"
                      colorPrimary={colorPrimary}
                      colorSecondary={colorSecondary}
                      data={[
                        {
                          name: "Branding",
                          data: [
                            { x: new Date("02/01/2016"), y: 0 },
                            { x: new Date("04/01/2016"), y: 98 },
                            { x: new Date("06/01/2016"), y: 56 },
                            { x: new Date("08/01/2016"), y: 12 },
                            { x: new Date("10/01/2016"), y: 5 },
                            { x: new Date("12/01/2016"), y: 31 },
                            { x: new Date("02/01/2017"), y: 53 },
                            { x: new Date("04/01/2017"), y: 0 }
                          ]
                        },

                        {
                          name: "Website Design",
                          data: [
                            { x: new Date("02/01/2016"), y: 0 },
                            { x: new Date("04/01/2016"), y: 15 },
                            { x: new Date("06/01/2016"), y: 70 },
                            { x: new Date("08/01/2016"), y: 51 },
                            { x: new Date("10/01/2016"), y: 25 },
                            { x: new Date("12/01/2016"), y: 27 },
                            { x: new Date("02/01/2017"), y: 16 },
                            { x: new Date("04/01/2017"), y: 5 },
                            { x: new Date("06/01/2017"), y: 25 },
                            { x: new Date("08/01/2017"), y: 54 },
                            { x: new Date("10/01/2017"), y: 74 },
                            { x: new Date("12/01/2017"), y: 46 },
                            { x: new Date("02/01/2018"), y: 34 },
                            { x: new Date("04/01/2018"), y: 11 },
                            { x: new Date("06/01/2018"), y: 45 },
                            { x: new Date("08/01/2018"), y: 99 },
                            { x: new Date("10/01/2018"), y: 86 },
                            { x: new Date("12/01/2018"), y: 40 },
                            { x: new Date("02/01/2019"), y: 27 },
                            { x: new Date("04/01/2019"), y: 0 }
                          ]
                        },

                        {
                          name: "eCommerce",
                          data: [
                            { x: new Date("06/01/2016"), y: 0 },
                            { x: new Date("08/01/2016"), y: 28 },
                            { x: new Date("10/01/2016"), y: 90 },
                            { x: new Date("12/01/2016"), y: 60 },
                            { x: new Date("02/01/2017"), y: 33 },
                            { x: new Date("04/01/2017"), y: 37 },
                            { x: new Date("06/01/2017"), y: 55 },
                            { x: new Date("08/01/2017"), y: 27 },
                            { x: new Date("10/01/2017"), y: 0 }
                          ]
                        },

                        {
                          name: "Companion App",
                          data: [
                            { x: new Date("10/01/2017"), y: 0 },
                            { x: new Date("11/01/2017"), y: 33 },
                            { x: new Date("12/01/2017"), y: 80 },
                            { x: new Date("02/01/2018"), y: 100 },
                            { x: new Date("04/01/2018"), y: 91 },
                            { x: new Date("06/01/2018"), y: 76 },
                            { x: new Date("08/01/2018"), y: 66 },
                            { x: new Date("10/01/2018"), y: 20 },
                            { x: new Date("12/01/2018"), y: 0 }
                          ]
                        },

                        {
                          name: "Marketing",
                          data: [
                            { x: new Date("10/01/2018"), y: 0 },
                            { x: new Date("12/01/2018"), y: 34 },
                            { x: new Date("02/01/2019"), y: 80 },
                            { x: new Date("04/01/2019"), y: 0 }
                          ]
                        }
                      ]}
                    />
                    <Legend
                      id="project-timeline"
                      colorPrimary={colorPrimary}
                      colorSecondary={colorSecondary}
                      data={[
                        { name: "Branding" },
                        { name: "Website Design" },
                        { name: "eCommerce" },
                        { name: "Companion App" },
                        { name: "Marketing" }
                      ]}
                    />
                  </div>
                  <div style={{ gridColumn: "6/7" }}>
                    <Graph>
                      <RadialChart
                        innerRadius={sizes.space * 2 - sizes.space * 0.5}
                        radius={sizes.space * 2}
                        data={projDistro}
                        width={152}
                        height={152}
                        padAngle={0.04}
                        colorType="literal"
                      />
                    </Graph>
                  </div>
                </Grid>
              </Typeset>
            </Typepad>
          </BgColor>

          <BgColor>
            <Grid>
              <div
                className="bg-image"
                style={{
                  gridColumn: "1/7",
                  backgroundImage: "url(" + p_frv_web_1bg + ")"
                }}
              >
                <ImgPad dropShadow>
                  <Lightbox images={this.state.images} currentIndex={0} />
                </ImgPad>
              </div>
            </Grid>
          </BgColor>

          <Typepad style={{ paddingBottom: "0" }}>
            <Typeset>
              <ImgGridS>
                <div style={{ gridColumn: "1/7", textAlign: "center" }}>
                  <p className="text-lg">
                    Fractured Veil Companion App allows players to manage their
                    friends, team, characters, inventory, and account settings.
                    Built using React.Js and Redux, the companion app is
                    accessible from any device using a standard web browser.
                  </p>
                </div>
              </ImgGridS>
            </Typeset>
          </Typepad>

          <ImgGridS>
            <div style={{ gridColumn: "1/2" }}>
              <ImgPad dropShadow>
                <Lightbox images={this.state.images} currentIndex={1} />
              </ImgPad>
            </div>
            <div style={{ gridColumn: "2/5" }}>
              <ImgPad dropShadow>
                <Lightbox images={this.state.images} currentIndex={2} />
              </ImgPad>
            </div>
            <div style={{ gridColumn: "5/7" }}>
              <ImgPad dropShadow>
                <Lightbox images={this.state.images} currentIndex={3} />
              </ImgPad>
            </div>
          </ImgGridS>

          <div css={theme => ({ background: "#E5E5E3" })}>
            <ImgGridS>
              <div style={{ gridColumn: "1/5" }}>
                <ImgPad dropShadow>
                  <Lightbox images={this.state.images} currentIndex={4} />
                </ImgPad>
              </div>
              <div style={{ gridColumn: "5/7" }}>
                <ImgPad dropShadow>
                  <Lightbox images={this.state.images} currentIndex={5} />
                </ImgPad>
                <ImgPad>
                  <Lightbox images={this.state.images} currentIndex={6} />
                </ImgPad>
              </div>
            </ImgGridS>
          </div>

          <ImgGridS>
            <div style={{ gridColumn: "1/3" }}>
              <ImgPad dropShadow>
                <Lightbox images={this.state.images} currentIndex={7} />
              </ImgPad>
            </div>
            <div style={{ gridColumn: "3/5" }}>
              <ImgPad dropShadow>
                <Lightbox images={this.state.images} currentIndex={8} />
              </ImgPad>
            </div>
            <div style={{ gridColumn: "5/7" }}>
              <ImgPad dropShadow>
                <Lightbox images={this.state.images} currentIndex={9} />
              </ImgPad>
            </div>
          </ImgGridS>

          <BgColor2>
            <Typepad>
              <Typeset>
                <ImgGridS>
                  <div style={{ gridColumn: "1/7", textAlign: "center" }}>
                    <p className="lead">More Coming Soon</p>
                  </div>
                </ImgGridS>
              </Typeset>
            </Typepad>
          </BgColor2>

          <BgColor>
            <Typepad style={{ textAlign: "center" }}>
              <Link to="/?p=fracturedveil">
                <ButtonSecondary>
                  Back to Portfolio
                </ButtonSecondary>
              </Link>
            </Typepad>
          </BgColor>

          <Footer />
        </div>
      </ThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Work/FracturedVeil.js